import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Pageheading from '../../../widgets/PageHeading';
import ContactForm1 from '../../../widgets/contact/ContactForm1';
import { Link } from 'react-router-dom';
const Contact1 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {/* hero section start */}
            {/*<section className="position-relative">*/}
            {/*    <Pageheading foldername="Company" title="Contact" />*/}
            {/*    /!*<h1>Contact</h1>*!/*/}
            {/*</section>*/}
            {/* hero section end */}
            {/* body content start */}
            <div className="page-content">

                <section>
                    <Container>
                        <Row className="justify-content-center mb-5 text-center">
                            <Col lg="8">
                                <div>
                                    {/*<span className="badge badge-primary-soft p-2">*/}
                                    {/*    /!*<i className="la la-bold ic-3x rotation" />*!/*/}
                                    {/*    <i className="la la-check text-primary fw-bold"/>*/}
                                    {/*</span>*/}
                                    <h2 className="mt-4 mb-0">Lasă-ne un mesaj</h2>
                                    <p className="lead mb-0">Suntem aici pentru a răspunde întrebărilor tale și pentru a te sprijini în orice ai nevoie. Completează formularul de mai jos și trimite-ne un mesaj. Echipa noastră va lua în considerare solicitarea ta și va reveni la tine în cel mai scurt timp posibil. Mulțumim pentru interesul acordat și pentru că ai ales să comunici cu noi!</p>
                                </div>
                            </Col>
                        </Row>
                        <ContactForm1 />
                    </Container>
                </section>
                <section>
                    <Container>
                        <Row className="text-center">
                            <Col lg="6" md="6" className='pb-5'>
                                <div>
                                    <svg
                                        className="feather feather-mail"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={50}
                                        height={50}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#1ec8ff"
                                        strokeWidth={1}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                        <polyline points="22,6 12,13 2,6" />
                                    </svg>
                                    <h4 className="mt-5">Email</h4>
                                    <Link to="mailto:office@premium-cms.ro">office@premium-cms.ro</Link>
                                </div>
                            </Col>
                            <Col lg="6" md="6" className='pb-5'>
                                <div>
                                    <svg
                                        className="feather feather-phone-call"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={50}
                                        height={50}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#1ec8ff"
                                        strokeWidth={1}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                    </svg>
                                    <h4 className="mt-5">Telefon</h4>
                                    <Link to="tel:+40721075270">+40 721 075 270</Link>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
            {/* body content end */}
        </div>
    );
};

export default Contact1;
